(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__customFooterAccordionBound) return;
  window.__customFooterAccordionBound = true;
  var mobile = window.matchMedia('(max-width: 749px)');
  function sync(column) {
    var toggle = column.querySelector('.custom-footer__menu-toggle');
    var panel = column.querySelector('.custom-footer__links-panel');
    if (!toggle || !panel) return;
    var expanded = !mobile.matches || column.classList.contains('is-open');
    column.classList.add('is-enhanced');
    toggle.disabled = !mobile.matches;
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.inert = !expanded;
  }
  function init() { document.querySelectorAll('.custom-footer__menu-column').forEach(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  mobile.addEventListener('change', init);
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.custom-footer__menu-toggle');
    if (!toggle || !mobile.matches) return;
    var column = toggle.closest('.custom-footer__menu-column');
    column.classList.toggle('is-open');
    sync(column);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geosort-comparison-table"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations=new Map();
  function reveal(detail,expanded,animate){
    // Read the current frame before cancelling so rapid toggles reverse smoothly.
    const height=detail.getBoundingClientRect().height;
    const opacity=detail.hidden?0:Number(getComputedStyle(detail).opacity);
    const previous=animations.get(detail);
    if(previous){previous.cancel();animations.delete(detail);}
    detail.hidden=false;
    detail.inert=!expanded;
    detail.setAttribute('aria-hidden',String(!expanded));
    const finish=()=>{
      detail.hidden=!expanded;
      detail.style.removeProperty('overflow');
      animations.get(detail)?.cancel();
      animations.delete(detail);
    };
    const target=expanded?detail.getBoundingClientRect().height:0;
    if(!animate||motion.matches||!detail.animate||height===target){finish();return;}
    detail.style.overflow='hidden';
    const animation=detail.animate([
      {height:`${height}px`,opacity},
      {height:`${target}px`,opacity:expanded?1:0}
    ],{duration:300,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
    animations.set(detail,animation);
    animation.onfinish=finish;
  }
  motion.addEventListener('change',()=>{if(motion.matches)animations.forEach(animation=>animation.finish());});
  document.addEventListener('shopify:section:unload',event=>{
    animations.forEach((animation,detail)=>{if(event.target.contains(detail)){animation.cancel();animations.delete(detail);}});
  });
  function init(root){
    if(root.dataset.gcReady)return;
    root.dataset.gcReady='true';
    const bar=root.querySelector('.gc-table-filters');
    const rows=[...root.querySelectorAll('[data-gc-topic]')];
    const details=root.querySelector('[data-gc-details]');
    bar.querySelectorAll('[data-gc-filter]').forEach(button=>{
      button.hidden=button.dataset.gcFilter!=='all'&&!rows.some(row=>row.dataset.gcTopic===button.dataset.gcFilter);
    });
    function setExpanded(row,expanded,animate=true){
      row.querySelector('.gc-row-toggle').setAttribute('aria-expanded',String(expanded));
      row.querySelectorAll('.gc-row-detail').forEach(detail=>reveal(detail,expanded,animate));
    }
    function syncDetails(){
      const shown=rows.filter(row=>!row.hidden);
      const expanded=shown.filter(row=>row.querySelector('.gc-row-toggle').getAttribute('aria-expanded')==='true').length;
      details.checked=shown.length>0&&expanded===shown.length;
      details.indeterminate=expanded>0&&expanded<shown.length;
    }
    rows.forEach(row=>{const button=row.querySelector('.gc-row-toggle');button.hidden=false;setExpanded(row,false,false);button.addEventListener('click',()=>{setExpanded(row,button.getAttribute('aria-expanded')!=='true');syncDetails();});});
    root.querySelector('.gc-table-toolbar').hidden=false;
    details.addEventListener('change',()=>{rows.filter(row=>!row.hidden).forEach(row=>setExpanded(row,details.checked));syncDetails();});
    bar.addEventListener('click',event=>{
      const button=event.target.closest('[data-gc-filter]');if(!button)return;
      bar.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      rows.forEach(row=>{
        setExpanded(row,row.querySelector('.gc-row-toggle').getAttribute('aria-expanded')==='true',false);
        row.hidden=button.dataset.gcFilter!=='all'&&row.dataset.gcTopic!==button.dataset.gcFilter;
      });
      syncDetails();
    });
  }
  document.querySelectorAll('[data-gc-comparison]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gc-comparison]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geosort-custom-quote"] && !Shopify.designMode) return;
  try {
    
(()=>{
  function init(root){
    if(root.dataset.quoteReady)return;root.dataset.quoteReady='true';
    const success=root.querySelector('[data-quote-success]');
    const errors=root.querySelector('[data-quote-errors]');
    // Shopify returns here only after accepting the native contact form (including CAPTCHA).
    if(!errors&&new URLSearchParams(location.search).get('contact_posted')==='true')success.hidden=false;
    if(!success.hidden){
      root.querySelector('[data-quote-fields]').hidden=true;
      success.focus({preventScroll:true});
      // Let the browser finish its return-URL anchor jump before announcing confirmation.
      const announce=()=>requestAnimationFrame(()=>{
        if(document.activeElement===document.body||root.contains(document.activeElement)){
          success.scrollIntoView({block:'center'});success.focus({preventScroll:true});
        }
      });
      if(document.readyState==='complete')announce();else window.addEventListener('load',announce,{once:true});
    }
    if(errors){errors.focus({preventScroll:true});errors.scrollIntoView({block:'center'});}
  }
  document.querySelectorAll('[data-gcquote]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gcquote]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geosort-feature-local-commerce"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const countryData = {
      fr: {name:"🇫🇷 France",order:[1,0,3,2]}, de:{name:"🇩🇪 Germany",order:[0,3,1,2]},
      us: {name:"🇺🇸 United States",order:[0,3,1,2]}, es:{name:"🇪🇸 Spain",order:[1,2,0,3]},
      gb: {name:"🇬🇧 United Kingdom",order:[3,0,1,2]}, au:{name:"🇦🇺 Australia",order:[2,1,3,0]},
      nz: {name:"🇳🇿 New Zealand",order:[1,2,0,3]}, jp:{name:"🇯🇵 Japan",order:[3,1,0,2]},
      ca: {name:"🇨🇦 Canada",order:[1,0,2,3]}
    };
    function init(section) {
      if (section.dataset.gflReady) return;
      section.dataset.gflReady = "true";
      const rows = [...section.querySelectorAll("[data-gfl-country-row]")].map(row => ({element:row,grid:row.querySelector("[data-gfl-products]"),products:[...row.querySelectorAll("[data-gfl-product]")]}));
      const reduced = matchMedia("(prefers-reduced-motion:reduce)");
      const live = section.dataset.mode === "live";
      const individualCountries = !live && section.dataset.individualCountries === "true";
      const selectedCountries = ["us","es"];
      let group = individualCountries ? "country" : "region", region = "emea", season = "summer", visible = false, editorSelected = false, eventTimer;
      let paused = section.dataset.autoplay !== "true";
      let phase = reduced.matches || paused ? 4 : 0;
      const phaseDurations = [2000,1000,2200,1000,2800];
      const playback = section.querySelector("[data-gfl-playback]");
      const liveCopy = live ? JSON.parse(section.querySelector("[data-gfl-live-copy]").textContent) : null;
      const productScores=new Map(rows.flatMap(row=>row.products).map(product=>{
        try{return [product,JSON.parse(product.dataset.gflScores||'{}')];}catch{return [product,{}];}
      }));
      function countryProductOrder(row,code,selectedSeason){
        return row.products.filter(product=>!selectedSeason||product.dataset.gflSeason===selectedSeason).sort((a,b)=>Number(productScores.get(b)[code]||0)-Number(productScores.get(a)[code]||0)||Number(a.dataset.gflProduct)-Number(b.dataset.gflProduct)).slice(0,4).map(product=>Number(product.dataset.gflProduct));
      }
      function reorder(row, ids, animate) {
        row.products.forEach(product => product.getAnimations().forEach(animation => animation.cancel()));
        const first = new Map(row.products.filter(product=>!product.hidden).map(product => [product,product.getBoundingClientRect()]));
        const ordered = ids.map(id => row.products.find(product => Number(product.dataset.gflProduct) === id)).filter(Boolean);
        if(live)ordered.push(...row.products.filter(product => !ordered.includes(product)));
        row.products.forEach(product=>product.hidden=!ordered.includes(product));
        ordered.forEach((product,index) => {row.grid.appendChild(product);product.querySelector("[data-gfl-rank]").textContent = index + 1;});
        if (!animate || reduced.matches) return;
        ordered.forEach(product => {
          const a = first.get(product), b = product.getBoundingClientRect();
          if(!a){product.animate([{opacity:0},{opacity:1}],{duration:350});return;}
          const x = a.left-b.left, y = a.top-b.top;
          if (Math.abs(x)+Math.abs(y)>1) product.animate([{transform:`translate(${x}px,${y}px)`},{transform:"translate(0,0)"}],{duration:650,easing:"cubic-bezier(.22,1,.36,1)"});
        });
      }
      function render(animate = true) {
        if (live) {
          const row = rows[0];
          const ids = row.products.map(product=>Number(product.dataset.gflProduct));
          let order = [...countryData.us.order.filter(id=>ids.includes(id)),...ids.filter(id=>!countryData.us.order.includes(id))];
          if (phase >= 2 && order.includes(0)) order = order.filter(id=>id!==0).concat(0);
          if (phase >= 4 && order.includes(2)) order = [2,...order.filter(id=>id!==2)];
          row.products.forEach(product=>{
            const unavailable = phase >= 1 && product.dataset.gflProduct === "0";
            const trending = phase >= 3 && product.dataset.gflProduct === "2";
            product.classList.toggle("is-unavailable",unavailable);
            product.classList.toggle("is-trending",trending);
            const label = product.querySelector("[data-gfl-product-state]");
            label.hidden = !unavailable && !trending;
            label.textContent = unavailable ? liveCopy.soldOut : trending ? liveCopy.trending : "";
          });
          if (order.some((id,index)=>Number(row.grid.children[index]?.dataset.gflProduct)!==id)) reorder(row,order,animate);
          section.dataset.livePhase = String(phase);
          return;
        }
        const seasonButton = section.querySelector('[data-gfl-season-choice="'+season+'"]');
        const apac = region === 'apac';
        const codes = group === "country" ? selectedCountries : group === "region" ? (apac ? ["au","jp"] : ["fr","de"]) : group === "markets" ? ["us","ca"] : ["fr","de"];
        section.querySelector('.gfl-group').hidden = group === "country";
        section.querySelector("[data-gfl-group-name]").hidden = group !== "markets";
        section.querySelector('[data-gfl-region-picker]').hidden = group !== 'region';
        section.querySelector("[data-gfl-season-picker]").hidden = group !== "season";
        section.querySelectorAll("[data-gfl-region-choice]").forEach(button=>button.setAttribute("aria-pressed",String(button.dataset.gflRegionChoice===region)));
        section.querySelectorAll("[data-gfl-season-choice]").forEach(button=>button.setAttribute("aria-pressed",String(button.dataset.gflSeasonChoice===season)));
        section.querySelectorAll("[data-gfl-group]").forEach(button => button.setAttribute("aria-pressed",String(button.dataset.gflGroup === group)));
        const members = section.querySelector("[data-gfl-members]");
        members.replaceChildren(...codes.map(code => {const chip=document.createElement("span");chip.textContent=countryData[code].name;return chip;}));
        const note = section.querySelector("[data-gfl-group-note]");
        note.textContent = group === "country" ? note.dataset.individualNote : group === "season" ? seasonButton.dataset.gflSeasonNote : group === "markets" ? "Use your Shopify Markets to share a strategy. Each country still ranks its own bestsellers." : "One regional strategy. Each country keeps its own rankings.";
        rows.forEach((row,index) => {
          const country = countryData[codes[index]];
          const order = countryProductOrder(row,codes[index],group==='season'?season:null);
          row.element.querySelector("[data-gfl-country-name]").textContent = country.name;
          row.element.querySelector("[data-gfl-country-name]").hidden = group === "country";
          const selector = row.element.querySelector('[data-gfl-country-select]');
          if(selector){
            selector.hidden = group !== "country";
            selector.value = selectedCountries[index];
            [...selector.options].forEach(option=>option.disabled=option.value===selectedCountries[1-index]);
          }
          row.element.querySelector("[data-gfl-country-status]").textContent = "Local bestsellers";
          reorder(row,order,animate);
        });
      }
      function schedule() {
        clearTimeout(eventTimer);
        if (!live) return;
        const running = !paused && !reduced.matches && visible && section.isConnected && !document.hidden && !editorSelected;
        section.querySelector(".gfl-demo").getAnimations({subtree:true}).forEach(animation=>{
          if (!running) animation.pause();
          else if (animation.playState === "paused") animation.play();
        });
        section.dataset.liveRunning = String(running);
        if (!running) return;
        eventTimer=setTimeout(()=>{phase=(phase+1)%phaseDurations.length;render();schedule();},phaseDurations[phase]);
      }
      function updatePlayback() {
        playback.hidden = reduced.matches;
        playback.setAttribute("aria-label",paused ? liveCopy.resume : liveCopy.pause);
        playback.title = paused ? liveCopy.resume : liveCopy.pause;
        playback.querySelector("[data-gfl-pause-icon]").toggleAttribute("hidden",paused);
        playback.querySelector("[data-gfl-play-icon]").toggleAttribute("hidden",!paused);
      }
      if (live) {
        const onPlayback=()=>{paused=!paused;updatePlayback();schedule();};
        playback.addEventListener("click",onPlayback);
        document.addEventListener("visibilitychange",schedule);
        const cancelAnimations=()=>section.querySelector(".gfl-demo").getAnimations({subtree:true}).forEach(animation=>animation.cancel());
        const onMotion=()=>{cancelAnimations();phase=reduced.matches?4:0;render(false);updatePlayback();schedule();};
        reduced.addEventListener("change",onMotion);
        const onEditor=event=>{if(event.target.contains(section)){editorSelected=event.type==="shopify:section:select";schedule();}};
        const onResize=()=>{cancelAnimations();schedule();};
        window.addEventListener("resize",onResize);
        document.addEventListener("shopify:section:select",onEditor);
        document.addEventListener("shopify:section:deselect",onEditor);
        const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.4;schedule();},{threshold:[0,.4]});
        observer.observe(section.querySelector(".gfl-demo"));
        cleanups.set(section,()=>{clearTimeout(eventTimer);cancelAnimations();observer.disconnect();playback.removeEventListener("click",onPlayback);document.removeEventListener("visibilitychange",schedule);reduced.removeEventListener("change",onMotion);window.removeEventListener("resize",onResize);document.removeEventListener("shopify:section:select",onEditor);document.removeEventListener("shopify:section:deselect",onEditor);delete section.dataset.gflReady;});
        updatePlayback();
      } else {
        const toggle=section.querySelector('[data-gfl-group-toggle]');
        const panel=section.querySelector('[data-gfl-group-panel]');
        let expanded=false, expansion;
        function finishExpansion(){
          expansion?.cancel();expansion=null;
          panel.hidden=!expanded;
          panel.style.height='';panel.style.overflow='';
        }
        const onToggle=()=>{
          const start=panel.getBoundingClientRect().height;
          expansion?.cancel();
          expanded=!expanded;toggle.setAttribute('aria-expanded',String(expanded));
          const label=expanded?toggle.dataset.collapseLabel:toggle.dataset.expandLabel;
          toggle.setAttribute('aria-label',label);toggle.title=label;
          if(reduced.matches){finishExpansion();return;}
          panel.hidden=false;panel.style.height='';
          const end=expanded?panel.scrollHeight:0;
          panel.style.height=start+'px';panel.style.overflow='hidden';
          expansion=panel.animate([{height:start+'px'},{height:end+'px'}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)'});
          expansion.onfinish=finishExpansion;
        };
        toggle.addEventListener('click',onToggle);
        const onMotion=()=>{if(reduced.matches)finishExpansion();};
        reduced.addEventListener('change',onMotion);
        cleanups.set(section,()=>{finishExpansion();toggle.removeEventListener('click',onToggle);reduced.removeEventListener('change',onMotion);});
        section.querySelectorAll("[data-gfl-group]").forEach(button=>button.addEventListener("click",()=>{finishExpansion();group=button.dataset.gflGroup;render();}));
        section.querySelectorAll("[data-gfl-season-choice]").forEach(button=>button.addEventListener("click",()=>{finishExpansion();season=button.dataset.gflSeasonChoice;render();}));
        section.querySelectorAll("[data-gfl-region-choice]").forEach(button=>button.addEventListener("click",()=>{finishExpansion();region=button.dataset.gflRegionChoice;render();}));
        section.querySelectorAll('[data-gfl-country-select]').forEach((selector,index)=>selector.addEventListener('change',()=>{
          if(!countryData[selector.value]||selector.value===selectedCountries[1-index]){selector.value=selectedCountries[index];return;}
          selectedCountries[index]=selector.value;render();
        }));
      }
      render(false);schedule();
    }
    document.querySelectorAll("[data-gfl]").forEach(init);
    document.addEventListener("shopify:section:load",event=>event.target.querySelectorAll("[data-gfl]").forEach(init));
    document.addEventListener("shopify:section:unload",event=>event.target.querySelectorAll("[data-gfl]").forEach(section=>cleanups.get(section)?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geosort-feature-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(section) {
      if (section.dataset.gfsReady) return;
      section.dataset.gfsReady = "true";
      const mode = section.dataset.mode;
      const grid = section.querySelector("[data-gfs-products]");
      const products = [...section.querySelectorAll("[data-gfs-product]")];
      const toggle = section.querySelector("[data-gfs-toggle]");
      const status = section.querySelector("[data-gfs-preview-status]");
      const reduced = window.matchMedia("(prefers-reduced-motion:reduce)");
      const controls = section.querySelectorAll("input,select,button");
      let country = section.querySelector("[data-gfs-country]")?.value || "us";
      let restockState = "sold";
      const restockCopy = mode === "restock" ? JSON.parse(section.querySelector("[data-gfs-restock-copy]").textContent) : null;
      const abChart = mode === "ab" ? section.querySelector("[data-gfs-ab-chart]") : null;
      function updateAbChart(animate = true) {
        if (!abChart) return;
        const option = abChart.querySelector("[data-gfs-ab-metric]").selectedOptions[0];
        if (!option) return;
        const values = [option.dataset.control,option.dataset.variant];
        const numbers = values.map(value=>Number(value.replace(/[^0-9.-]/g,"")));
        const plot = abChart.querySelector("[data-gfs-ab-plot]");
        const valid = values.every(value=>/\d/.test(value)) && numbers.every(value=>Number.isFinite(value) && value>=0);
        plot.hidden = !valid;
        if (!valid) return;
        const highest = Math.max(...numbers,0.01);
        const step = Math.pow(10,Math.floor(Math.log10(highest)))/2;
        const maximum = Math.ceil(highest/step)*step;
        const percent = values.every(value=>value.includes("%"));
        const summary = ["control","variant"].map((key,index)=>{
          const bar = abChart.querySelector('[data-gfs-ab-bar="'+key+'"]');
          const label = abChart.querySelector('[data-gfs-ab-series-label="'+key+'"]').textContent;
          const share = numbers[index]/maximum;
          bar.getAnimations().forEach(animation=>animation.cancel());
          bar.style.setProperty("--bar-value",share);
          abChart.querySelector('[data-gfs-ab-value="'+key+'"]').textContent=values[index];
          if (animate && !reduced.matches) bar.animate([{transform:"scaleX(0)"},{transform:"scaleX("+share+")"}],{duration:700,easing:"cubic-bezier(.22,1,.36,1)"});
          return label+": "+values[index];
        });
        abChart.querySelectorAll("[data-gfs-ab-tick]").forEach((tick,index)=>{
          const value=Number((maximum*index/4).toPrecision(3));
          tick.textContent=value+(percent?"%":"");
        });
        const description=option.textContent+". "+summary.join(". ");
        plot.setAttribute("aria-label",description);
        abChart.querySelector("[data-gfs-ab-chart-summary]").textContent=description;
      }
      function score(product) { return Number(product.dataset[country === "es" ? "scoreEs" : "scoreUs"] || product.dataset.score || 0); }
      function reorder(order, animate = true) {
        if (!grid) return;
        products.forEach(product => product.getAnimations().forEach(animation => animation.cancel()));
        const before = new Map(products.map(product => [product,product.getBoundingClientRect()]));
        order.forEach((product,index) => { grid.appendChild(product);product.querySelector("[data-gfs-rank]").textContent = index+1; });
        if (!animate || reduced.matches) return;
        order.forEach(product => {
          const first = before.get(product),last = product.getBoundingClientRect();
          const x=first.left-last.left,y=first.top-last.top;
          if (Math.abs(x)+Math.abs(y)>1) product.animate([{transform:"translate("+x+"px,"+y+"px)"},{transform:"translate(0,0)"}],{duration:560,easing:"cubic-bezier(.22,1,.36,1)"});
        });
      }
      function update(animate = true) {
        let ordered = products.slice().sort((a,b)=>score(b)-score(a));
        if (mode === "grouping") {
          section.dataset.grouped = String(toggle.checked);
          if (toggle.checked) {
            const seen = new Set();
            ordered = ordered.flatMap(product => {
              const key = product.dataset.group;
              if (!key) return [product];
              if (seen.has(key)) return [];
              seen.add(key);
              return products.filter(item=>item.dataset.group===key).sort((a,b)=>score(b)-score(a));
            });
          }
          status.textContent = toggle.checked ? "Related products stay together, led by the strongest performer." : "Products follow their individual bestseller rank.";
        }
        if (mode === "interleaving") {
          const buckets = ["tshirt","hoodie","bottom"].map(type=>ordered.filter(product=>product.dataset.category===type));
          ordered = [];
          while (buckets.some(bucket=>bucket.length)) buckets.forEach(bucket=>ordered.push(...bucket.splice(0,1)));
        }
        if (mode === "sales") {
          section.dataset.saleActive = String(toggle.checked);
          section.querySelector("[data-gfs-enabled-label]").textContent = toggle.checked ? "On" : "Off";
          section.querySelector("[data-gfs-sale-status]").textContent = toggle.checked ? "Excluded from Best Sellers" : "Included in Best Sellers";
          section.querySelector("[data-gfs-sales-result]").textContent = toggle.checked ? "Best Sellers reflect demand beyond the sale." : "Promotional sales still influence Best Sellers.";
        }
        if (mode === "restock") {
          const days = Number(section.querySelector("[data-gfs-days]").value);
          const duration = days === 1 ? restockCopy.oneDay : restockCopy.days.replace("[days]",days);
          section.querySelector("[data-gfs-days-output]").textContent = duration;
          section.dataset.restockState = restockState;
          section.querySelector("[data-gfs-restock-status]").textContent = restockCopy[restockState];
          section.querySelectorAll("[data-gfs-restock-step]").forEach(button=>button.setAttribute("aria-pressed",String(button.dataset.gfsRestockStep===restockState)));
          const target = products.find(product=>product.dataset.target==="true");
          if (target) {
            target.dataset.soldOut = String(restockState==="sold");
            target.classList.toggle("is-boosted",restockState==="boosted");
            target.querySelector(".gfs-product-label").textContent = restockCopy[restockState];
            if (restockState==="boosted") ordered = [target,...ordered.filter(product=>product!==target)];
            if (restockState==="sold" || restockState==="restocked") ordered = [...ordered.filter(product=>product!==target),target];
          }
          status.textContent = restockCopy[restockState+"Note"].replace("[duration]",duration);
        }
        if (mode === "stock") {
          const sizes = [...section.querySelectorAll("[data-gfs-size]")];
          const broken = sizes.every(input=>input.checked);
          const available = sizes.filter(input=>!input.checked).map(input=>input.value);
          section.dataset.broken = String(broken);
          section.querySelector("[data-gfs-stock-status]").textContent = broken ? "Broken stock detected" : "Sizes available";
          section.querySelector("[data-gfs-stock-outcome]").textContent = broken ? "S, M and L sold out. Product flagged and moved down." : available.join(", ")+" still available. Product keeps its position.";
          ordered.sort((a,b) => {
            const priority = product=>product.dataset.soldOut==="true" ? 2 : broken && product.dataset.target==="true" ? 1 : 0;
            return priority(a)-priority(b);
          });
          status.textContent = broken ? "Healthy stock first. Broken stock next. Sold out last." : "Available products keep their bestseller positions.";
        }
        reorder(ordered,animate);
      }
      controls.forEach(control => {
        if (control.matches("input,select")) control.addEventListener(control.type==="range"?"input":"change",()=>{
          if (control.matches("[data-gfs-ab-metric]")) { updateAbChart();return; }
          country=section.querySelector("[data-gfs-country]")?.value || country;update();
        });
        if (control.dataset.gfsAb) control.addEventListener("click",()=>{
          const choice=control.dataset.gfsAb;
          section.querySelectorAll("[data-gfs-ab]").forEach(button=>button.setAttribute("aria-pressed",String(button===control)));
          const order=section.querySelector("[data-gfs-ab-order]");
          order.hidden=choice==="results";
          section.querySelector("[data-gfs-ab-results]").hidden=choice!=="results";
          section.querySelector("[data-gfs-ab-note]").hidden=choice==="results";
          if (choice==="results") updateAbChart();
          else if (abChart) abChart.querySelectorAll("[data-gfs-ab-bar]").forEach(bar=>bar.getAnimations().forEach(animation=>animation.cancel()));
          if(choice!=="results") {
            const keys=choice==="variant"?["best","new","restock","low","sold"]:["new","restock","best","low","sold"];
            keys.forEach((key,index)=>{
              const layer=order.querySelector('[data-gfs-ab-layer="'+key+'"]');
              order.appendChild(layer);layer.querySelector(".gfs-layer-num").textContent=index+1;
            });
          }
        });
      });
      update(false);
      if (mode === "restock" && products.some(product=>product.dataset.target==="true")) {
        let timer = null, visible = false, started = false, automatic = false, editorSelected = false;
        const stop = () => { clearTimeout(timer);timer=null; };
        const schedule = () => {
          stop();
          if (!automatic || !visible || document.hidden || reduced.matches || editorSelected) return;
          const next = restockState === "sold" ? "restocked" : restockState === "restocked" ? "boosted" : null;
          if (!next) { automatic=false;return; }
          timer=setTimeout(()=>{ restockState=next;update();schedule(); },restockState==="sold"?1800:1200);
        };
        const observer = new IntersectionObserver(entries=>{
          visible=entries[0].isIntersecting;
          if (visible && !started) { started=true;automatic=!reduced.matches; }
          schedule();
        },{threshold:.55});
        observer.observe(section.querySelector(".gfs-visual"));
        section.querySelectorAll("[data-gfs-restock-step]").forEach(button=>button.addEventListener("click",()=>{
          started=true;restockState=button.dataset.gfsRestockStep;
          automatic=restockState==="sold" || restockState==="restocked";
          update();schedule();
        }));
        const motionChange = () => { if (reduced.matches) { automatic=false;products.forEach(product=>product.getAnimations().forEach(animation=>animation.cancel())); }schedule(); };
        const editorChange = event => { if (event.target.contains(section)) { editorSelected=event.type==="shopify:section:select";schedule(); } };
        const unload = event => {
          if (!event.target.contains(section)) return;
          stop();observer.disconnect();
          document.removeEventListener("visibilitychange",schedule);
          reduced.removeEventListener("change",motionChange);
          document.removeEventListener("shopify:section:select",editorChange);
          document.removeEventListener("shopify:section:deselect",editorChange);
          document.removeEventListener("shopify:section:unload",unload);
        };
        document.addEventListener("visibilitychange",schedule);
        reduced.addEventListener("change",motionChange);
        document.addEventListener("shopify:section:select",editorChange);
        document.addEventListener("shopify:section:deselect",editorChange);
        document.addEventListener("shopify:section:unload",unload);
      }
    }
    document.querySelectorAll("[data-gfs]").forEach(init);
    document.addEventListener("shopify:section:load",event=>event.target.querySelectorAll("[data-gfs]").forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geosort-features-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(section) {
      if (section.dataset.gffReady === "true") return;
      section.dataset.gffReady = "true";
      const filters = [...section.querySelectorAll("[data-gff-filter]")];
      const cards = [...section.querySelectorAll("[data-gff-card]")];
      const expand = section.querySelector("[data-gff-expand]");
      let activeFilter = "all";
      let expanded = section.classList.contains("is-expanded");
      function update() {
        const matching = cards.filter(card => activeFilter === "all" || card.dataset.gffCategory === activeFilter);
        cards.forEach(card => {
          card.hidden = !matching.includes(card) || (!expanded && matching.indexOf(card) >= 6);
        });
        section.classList.toggle("is-expanded", expanded);
        section.classList.toggle("is-collapsed", !expanded);
        expand.hidden = matching.length <= 6;
        expand.closest(".gff-more").hidden = matching.length <= 6;
        expand.setAttribute("aria-expanded", String(expanded));
        expand.querySelector("[data-gff-expand-label]").textContent = expanded ? expand.dataset.collapseLabel : expand.dataset.expandLabel;
      }
      filters.forEach(filter => filter.addEventListener("click", () => {
        activeFilter = filter.dataset.gffFilter;
        filters.forEach(item => {
          item.classList.toggle("is-active", item === filter);
          item.setAttribute("aria-pressed", String(item === filter));
        });
        update();
      }));
      cards.forEach(card => {
        const trigger = card.querySelector(".gff-card-trigger");
        trigger.addEventListener("click", () => {
          const open = trigger.getAttribute("aria-expanded") !== "true";
          trigger.setAttribute("aria-expanded", String(open));
          card.classList.toggle("is-active", open);
          const detail = card.querySelector(".gff-card-details");
          if (detail) detail.hidden = !open;
        });
      });
      expand.addEventListener("click", () => {
        expanded = !expanded;
        update();
        if (!expanded) section.querySelector(".gff-tabs").scrollIntoView({block:"start",behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"});
      });
      update();
      // Direct feature links reveal a card even when it is outside the first six.
      function revealLinkedFeature() {
        const anchor = window.location.hash.slice(1);
        const card = cards.find(item => item.id && item.id === anchor);
        if (!card) return;
        activeFilter = 'all';
        expanded = expanded || cards.indexOf(card) >= 6;
        filters.forEach(filter => {
          const active = filter.dataset.gffFilter === 'all';
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', String(active));
        });
        update();
        card.classList.add('is-active');
        card.querySelector('.gff-card-trigger').setAttribute('aria-expanded', 'true');
        const detail = card.querySelector('.gff-card-details');
        if (detail) detail.hidden = false;
        requestAnimationFrame(() => card.scrollIntoView({ block: 'start', behavior: 'instant' }));
      }
      window.addEventListener('hashchange', revealLinkedFeature);
      revealLinkedFeature();
    }
    document.querySelectorAll("[data-geosort-features-explorer]").forEach(init);
    document.addEventListener("shopify:section:load", event => event.target.querySelectorAll("[data-geosort-features-explorer]").forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geosort-pricing-comparison"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const mobile=matchMedia('(max-width:749px)');
  function init(root){
    if(root.dataset.gpcmReady)return;
    root.dataset.gpcmReady='true';root.classList.add('is-enhanced');
    root.querySelector('[data-gpcm-tools]').hidden=false;root.querySelector('[data-gpcm-selects]').hidden=false;
    const selects=[...root.querySelectorAll('[data-compare-plan]')];
    const rows=[...root.querySelectorAll('[data-feature-row]')];
    let category='all';
    function render(){
      const selected=selects.map(s=>s.value);
      root.querySelectorAll('[data-plan-col]').forEach(cell=>cell.classList.toggle('is-unselected',!selected.includes(cell.dataset.planCol)));
      let visible=0;
      rows.forEach(row=>{
        const values=[...row.querySelectorAll('td')].filter(cell=>!mobile.matches||selected.includes(cell.dataset.planCol)).map(cell=>cell.dataset.value);
        row.hidden=(category!=='all'&&row.dataset.category!==category)||(root.querySelector('[data-differences]').checked&&new Set(values).size===1);
        if(!row.hidden)visible++;
      });
      root.querySelector('[data-gpcm-empty]').hidden=visible>0;
      selects.forEach((select,index)=>{select.querySelectorAll('option').forEach(option=>option.disabled=option.value===selects[1-index].value);});
    }
    root.querySelectorAll('[data-category][aria-pressed]').forEach(button=>button.addEventListener('click',()=>{
      category=button.dataset.category;
      root.querySelectorAll('[data-category][aria-pressed]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      render();
    }));
    selects.forEach(select=>select.addEventListener('change',render));
    root.querySelector('[data-differences]').addEventListener('change',render);
    mobile.addEventListener('change',render);root.gpcmCleanup=()=>mobile.removeEventListener('change',render);render();
  }
  document.querySelectorAll('[data-gpcm]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gpcm]').forEach(init));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-gpcm]').forEach(root=>root.gpcmCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
